export function Select({ className = "", children, ...props }) {
  return (
    <select
      className={[
        "w-full rounded-xl border px-3 py-2 transition",
      "bg-dulia-parchmentSoft text-dulia-ink border-dulia-line",
        "focus:outline-none focus:ring-2 focus:ring-dulia-gold/35 focus:border-dulia-lineStrong",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "dark:bg-dulia-nightSoft dark:text-dulia-parchment dark:border-dulia-lineStrong/30",
        "dark:focus:ring-dulia-gold/30 dark:focus:border-dulia-gold/60",
        className,
      ].join(" ")}
      {...props}
    >
      {children}
    </select>
  );
}

export function OptionGroup({ label, children }) {
  return <optgroup label={label}>{children}</optgroup>;
}

export default Select;